import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function CheckboxQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        d='M4 2.5H12C12.3978 2.5 12.7794 2.65804 13.0607 2.93934C13.342 3.22064 13.5 3.60218 13.5 4V12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5H4C3.60218 13.5 3.22064 13.342 2.93934 13.0607C2.65804 12.7794 2.5 12.3978 2.5 12V4C2.5 3.60218 2.65804 3.22064 2.93934 2.93934C3.22064 2.65804 3.60218 2.5 4 2.5ZM12.825 12.825C13.0438 12.6062 13.1667 12.3094 13.1667 12V4C13.1667 3.69058 13.0438 3.39384 12.825 3.17504C12.6062 2.95625 12.3094 2.83333 12 2.83333H4C3.69058 2.83333 3.39383 2.95625 3.17504 3.17504C2.95625 3.39383 2.83333 3.69058 2.83333 4V12C2.83333 12.3094 2.95625 12.6062 3.17504 12.825C3.39384 13.0438 3.69058 13.1667 4 13.1667H12C12.3094 13.1667 12.6062 13.0438 12.825 12.825Z'
        fill='white'
        stroke='#3E8FFA'
      />
      <path
        d='M9.8 5.59334L7.28 8.92667L6.19333 7.52001C6.08459 7.38033 5.92482 7.28956 5.74916 7.26768C5.5735 7.2458 5.39635 7.2946 5.25667 7.40334C5.11698 7.51208 5.02622 7.67185 5.00434 7.84751C4.98246 8.02317 5.03126 8.20033 5.14 8.34001L6.76 10.4133C6.82278 10.4928 6.90284 10.5569 6.99409 10.6008C7.08535 10.6447 7.1854 10.6672 7.28667 10.6667C7.38848 10.6664 7.48888 10.6429 7.58017 10.5978C7.67147 10.5527 7.75123 10.4873 7.81333 10.4067L10.86 6.40667C10.9679 6.26522 11.0151 6.08672 10.9913 5.91044C10.9676 5.73416 10.8748 5.57453 10.7333 5.46667C10.5919 5.35882 10.4134 5.31157 10.2371 5.33533C10.0608 5.35908 9.90119 5.45189 9.79333 5.59334H9.8Z'
        fill='#3E8FFA'
      />
    </SvgIcon>
  );
}
